import React from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";
import { CONTACT_INFO } from "../data/mock";
import Logo from "./Logo";

const Footer = () => {
  const { t, lang } = useLanguage();
  const navigate = useNavigate();
  const location = useLocation();

  const links = [
    { type: "scroll", id: "about", label: t.nav.about },
    { type: "scroll", id: "audience", label: t.nav.services },
    { type: "route", to: "/oferty-pracy", label: t.nav.jobs },
    { type: "route", to: "/faq", label: t.nav.faq },
    { type: "scroll", id: "contact", label: t.nav.contact },
  ];

  const handle = (item) => {
    if (item.type === "route") {
      navigate(item.to);
      window.scrollTo(0, 0);
    } else {
      if (location.pathname !== "/") {
        navigate("/");
        setTimeout(() => {
          const el = document.getElementById(item.id);
          if (el) el.scrollIntoView({ behavior: "smooth" });
        }, 280);
      } else {
        const el = document.getElementById(item.id);
        if (el) el.scrollIntoView({ behavior: "smooth" });
      }
    }
  };

  return (
    <footer className="border-t border-white/10 bg-black">
      <div className="container-px mx-auto max-w-7xl py-16">
        <div className="grid gap-12 md:grid-cols-3">
          <div>
            <Logo />
            <p className="mt-5 max-w-xs text-sm leading-relaxed text-white/55">{t.footer.tagline}</p>
          </div>

          <div>
            <h4 className="font-display text-sm font-semibold uppercase tracking-widest text-white/80">
              {t.footer.quickLinks}
            </h4>
            <ul className="mt-5 space-y-3">
              {links.map((l) => (
                <li key={l.label}>
                  <button
                    onClick={() => handle(l)}
                    className="text-sm text-white/55 hover:text-white transition-colors"
                  >
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-display text-sm font-semibold uppercase tracking-widest text-white/80">
              {t.footer.contactInfo}
            </h4>
            <ul className="mt-5 space-y-4 text-sm text-white/55">
              <li className="flex items-center gap-3">
                <Mail className="h-4 w-4 text-white/70" />
                <a href={`mailto:${CONTACT_INFO.email}`} className="hover:text-white transition-colors break-all">
                  {CONTACT_INFO.email}
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="h-4 w-4 text-white/70" />
                <a href={`tel:${CONTACT_INFO.phone.replace(/\s/g, "")}`} className="hover:text-white transition-colors">
                  {CONTACT_INFO.phone}
                </a>
              </li>
              <li className="flex items-center gap-3">
                <MapPin className="h-4 w-4 text-white/70" />
                <span>{CONTACT_INFO.address[lang]}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 border-t border-white/10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-white/40">
          <span>© {new Date().getFullYear()} PSS Group · {t.footer.rights}</span>
          <Link to="/polityka-prywatnosci" className="hover:text-white transition-colors">
            {t.footer.privacy}
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
